import { tenantMeta } from "./constants";

const tenant_key_name = 'tenant';

export const getTenantId = (user, token=null) => {
    if(isCustomer(user)) {
        return getTenantIdFromToken(token);
    }

    const client = getClient(user);
    let result = null;
    if(client) result = client.id;
    return result;
};

const getTenantIdFromToken = (token) => {
    if(!token) return null;
    const payload = parseToken(token);
    if(payload){
        return payload[tenantMeta.TENANT_ID];
    }
};

export const parseToken = (token) => {
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace('-', '+').replace('_', '/');
        return JSON.parse(Buffer.from(base64, 'base64').toString('binary'));
        
      } catch(_){
        return null;
      }
};


export const getClient = (user) => {
    if(!isSU(user) && !isServiceMember(user) && !isPaymentMember(user)) throw new Error('Unauthorized');
    const client = sessionStorage.getItem(tenant_key_name);
    let result = null;
    if(client) {
        result = JSON.parse(client);
    }
    return result;
};

export const setClient = (user, client) => {
    if(!isSU(user) && !isServiceMember(user) && !isPaymentMember(user)) throw new Error('Unauthorized');
    sessionStorage.setItem(tenant_key_name, JSON.stringify(client));
};

export const isSU = (user) => {
    return hasRole(user, 'SU');
};

export const isServiceMember = (user) => {
    return hasRole(user, 'service');
};

export const isCustomer = (user) => {
    return hasRole(user, 'customer');
};

export const isPaymentMember = (user) => {
    return hasRole(user, 'payment');
};

const hasRole = (user, roleName) => {
    let result = false;
    const roles = user['https://creators.makrwatch.com/user_roles'];
    if(roles) {
        result = roles.includes(roleName);
    }
    return result;
};
